// extracted by mini-css-extract-plugin
module.exports = {"mobilePopup":"GithubPopup_mobilePopup__ETWDt","desktopPopup":"GithubPopup_desktopPopup__lqwTF"};